import customAxiosInterceptor from "../customAxiosInterceptor";
import { ErrorResponse } from "../index";
import { Baner, BanerResponse } from "./BanerType";

// Fetch baners
// GET https://api.infocomp.ba/api/baner
export const fetchLargeBanersThunk = async (
  _: void,
  thunkAPI: any
): Promise<Baner[] | ReturnType<typeof thunkAPI.rejectWithValue>> => {
  try {
    const response = await customAxiosInterceptor.get<BanerResponse>("/baner", {
      params: { baner_type: "LARGE" },
    });
    return response.data.data;
  } catch (error: any) {
    const errorResponse = error.response.data as ErrorResponse;
    return thunkAPI.rejectWithValue(errorResponse.msg);
  }
};

export const fetchSmallBanersThunk = async (
  _: void,
  thunkAPI: any
): Promise<Baner[] | ReturnType<typeof thunkAPI.rejectWithValue>> => {
  try {
    const response = await customAxiosInterceptor.get<BanerResponse>("/baner", {
      params: { baner_type: "SMALL" },
    });
    return response.data.data;
  } catch (error: any) {
    const errorResponse = error.response.data as ErrorResponse;
    return thunkAPI.rejectWithValue(errorResponse.msg);
  }
};
